import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Home from "../components/Home/Home";
import LoginRegister from "../components/Logout/User/LoginRegister";
import LoginRegisterAdmin from "../components/Logout/Adminstrator/LoginRegister";
import LoginRegisterSadmin from "../components/Logout/SuperAdmin/Signin";
import ImagesPage from "../components/images/Images";
import Detail1 from "../components/UserDetailsForm/hospital/UserDetailsForm";
import Detail2 from "../components/UserDetailsForm/school/UserDetailsForm";
import Detail3 from "../components/UserDetailsForm/shop/UserDetailsForm";
import HospitalDashboard from "../components/Dashboard/hospital/Dash";
import SchoolDashboard from "../components/Dashboard/school/Dash";
import ShopDashboard from "../components/Dashboard/shop/Dash";
import Super from '../components/superadmin/SuperRoute'
import Sdash from "../Pages/Dashboard/index";
import Shospital from "../Pages/Inventory/index";
import Sschool from "../Pages/Orders/index";
import Sschop from "../Pages/Customers/index";

// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('userId');
//   return token ? children : <Navigate to="/login" replace />;
// };
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('adminId');
//   return token ? children : <Navigate to="/loginadmin" replace />;
// };
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('adminId');
//   return token ? children : <Navigate to="/loginsadmin" replace />;
// };
function RoutesLayout() {
  return (
    <Router>
      <Header />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginRegister />} />
          <Route path="/loginadmin" element={<LoginRegisterAdmin />} />
          <Route path="/loginsadmin" element={<LoginRegisterSadmin />} />
         
          <Route path="/details1" element={<Detail1 />} />
          <Route path="/details2" element={<Detail2 />} />
          <Route path="/details3" element={<Detail3 />} />
          <Route path="/dashboard/hospital" element={<HospitalDashboard />} />
          <Route path="/dashboard/school" element={<SchoolDashboard />} />
          <Route path="/dashboard/shop" element={<ShopDashboard />} />
           <Route path="/superadmin/dashboard" element={<Super/>}/>

          {/* <Route path="/d" element={<Sdash />} />
          <Route path="/inventory" element={<Shospital />} />
          <Route path="/orders" element={<Sschool />} />
          <Route path="/customers" element={<Sschop />} /> */}

          <Route path="/superadmin/*" element={<Super />}>
  <Route path="d" element={<Sdash />} />
  <Route path="inventory" element={<Shospital />} />
  <Route path="orders" element={<Sschool />} />
  <Route path="customers" element={<Sschop />} />
</Route>


          <Route path="/images" element={<ImagesPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default RoutesLayout;
